import api from "./api";
import { parseListPayload, extractAssignmentSummary } from "utils/paginationStats";

function authHeaders() {
  const token = localStorage.getItem("tk446655440000");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const EMPTY_ASSIGNMENT_FILTERS = {
  search: "",
  regNumber: "",
  status: "",
  provinceId: "",
  departmentId: "",
  subPrefectureId: "",
  establishmentId: "",
};

export const ASSIGNMENT_LIST_FILTER_KEYS = [
  "search",
  "regNumber",
  "status",
  "provinceId",
  "departmentId",
  "subPrefectureId",
  "establishmentId",
];

const NUMERIC_FILTER_KEYS = new Set([
  "provinceId",
  "departmentId",
  "subPrefectureId",
  "establishmentId",
]);

/** Build query params for GET /Assignment/summary */
export function buildAssignmentListParams({ pageNumber = 1, pageSize = 10, filters = {} } = {}) {
  const params = { pageNumber, pageSize };

  ASSIGNMENT_LIST_FILTER_KEYS.forEach((key) => {
    const raw = filters[key];
    if (raw === "" || raw == null) return;
    if (NUMERIC_FILTER_KEYS.has(key)) {
      const num = Number(raw);
      if (Number.isFinite(num) && num > 0) params[key] = num;
      return;
    }
    const value = String(raw).trim();
    if (value) params[key] = value;
  });

  return params;
}

export function parseAssignmentListResponse(data) {
  const rows = parseListPayload(data);
  const stats = extractAssignmentSummary(rows, data);
  return {
    rows,
    stats,
    activeFilters: data?.Stats?.Filters ?? data?.stats?.filters ?? null,
  };
}

export async function fetchAssignmentList({ pageNumber, pageSize, filters }) {
  const params = buildAssignmentListParams({ pageNumber, pageSize, filters });
  const res = await api.get("/Assignment/summary", { params, headers: authHeaders() });
  return parseAssignmentListResponse(res.data);
}
